import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from 'src/app/services/auth.service';

type VerifyState = 'verifying' | 'success' | 'error';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.scss'
})
export class VerifyEmailComponent implements OnInit {
  state: VerifyState = 'verifying';
  message = '';
  resending = false;
  resendForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
  ) {
    this.resendForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.state = 'error';
      this.message = 'This verification link is missing its token.';
      return;
    }

    try {
      const response = await this.auth.verifyEmail(token);

      if (response?.token) {
        this.state = 'success';
        this.message = response?.response?.message || 'Your email has been verified.';
        setTimeout(() => this.router.navigate(['/dashboard']), 2000);
      } else {
        this.state = 'error';
        this.message = response?.response?.message || 'This verification link is invalid.';
      }
    } catch (error: any) {
      this.state = 'error';
      this.message = error?.graphQLErrors?.[0]?.message
        || 'This verification link is invalid or has expired.';
    }
  }

  async resend(): Promise<void> {
    if (!this.resendForm.valid) {
      return;
    }
    this.resending = true;
    try {
      await this.auth.resendVerificationEmail(this.resendForm.value.email);
    } finally {
      this.resending = false;
    }
  }
}
